export const PROJECT_DOCS_CONFIG = {
    name            : 'Documents',
    menuName        : 'Docs',
    icon            : 'i5-sticky-note',
    // iconLight       : 'i5-document-light',
    image           : 'notes-docs',
    iconSvg         : 'isvg-view-documents',
    url             : 'docs',
    stringId        : 'docs',
    description     : 'Create and manage project-related documents, notes, articles and other types of rich text files.',
    inheritance     : true,
    isSingleton     : true,
}
